import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL;

const publicAxios = axios.create({
  baseURL:  `${API_BASE}`,//"http://localhost:8080", //  
  headers: { 'Content-Type': 'application/json' },
});

export default publicAxios;